import * as CONSTANTS from '../utils/constants/constants';
import { axiosConfig } from '../api/axios';
import { ServiceEndPoints } from './constants/ApiConstant';
import * as actions from '../store/actions/index';

/**
 * Method to get the maximum weight to amend Service point
 *
 * @param {*} data - array of object from "productCountryFeature" API
 * @returns - number - Maximum unique data from filtered array of object
 */
export const getServicepointWeight = (data) => {
  const filteredMaxWeight = data
    .filter(
      (ele) =>
        ele.addressType === CONSTANTS.AMEND_SERVICE_POINT.ADDRESS_TYPE &&
        (ele.productCode === CONSTANTS.AMEND_SERVICE_POINT.PRO_CODE_210 ||
          ele.productCode === CONSTANTS.AMEND_SERVICE_POINT.PRO_CODE_220 ||
          ele.productCode === CONSTANTS.AMEND_SERVICE_POINT.PRO_CODE_1),
    )
    .map((x) => x.maximumWeight);

  const uniqueMaxWeight = [...new Set(filteredMaxWeight)][0];
  return uniqueMaxWeight;
};

/**
 * Method to get the customsDeclaration from products list
 *
 * @returns boolean
 */
export const getCustomDeclaration = (allProducts = []) => {
  // Ensure allProducts is an array
  if (!Array.isArray(allProducts)) {
    throw new Error('Expected an array');
  }

  // Check if any product requires a customs declaration
  const showClearanceDeclaration = allProducts.some(
    (product) =>
      product?.deliveryCapabilities?.accountType === CONSTANTS.CLERANCE_DECLARATION.PRODUCT_ACCOUNT_TYPE &&
      product?.deliveryCapabilities?.customsDeclaration === CONSTANTS.CLERANCE_DECLARATION.CUSTOM_DECLARATION,
  );

  return showClearanceDeclaration;
};

/**
 * Method to get Clearance Declaration Details to diplay
 */
export const getClearanceDeclarationDetails = (
  id,
  setClearanceDeclarationDetails,
  setShowClearanceDeclarationDetails,
  dispatch,
) => {
  return () => {
    axiosConfig
      .get(`${ServiceEndPoints.getClearanceDeclarationDetails}/${id}`)
      .then((res) => {
        setClearanceDeclarationDetails(res.data);
        setShowClearanceDeclarationDetails(true);
      })
      .catch((err) => {
        dispatch(
          actions.setBottomAlert({
            msgs: [
              {
                type: CONSTANTS.CLERANCE_DECLARATION.CATCH_MSG_TYPE,
                msg: CONSTANTS.CLERANCE_DECLARATION.CATCH_MSG,
              },
            ],
          }),
        );
      });
  };
};

/**
 * Method to get commodity (unit quantity*unit weight) total when shipment movement type
 * @param {*} values - object
 * @returns number
 */
export const getCommodityTotalWeight = (values) => {
  let commodityTotalWeight = 0;
  values?.commodityDetails?.forEach((commodity) => {
    commodityTotalWeight += commodity.quantity * commodity.unitWeight;
  });
  const totalWeight = Number(parseFloat(commodityTotalWeight).toFixed(2));
  return totalWeight;
}

/**
 * Method to get the Maximum Weight Per Parcel With Full Customs for windsor
 *
 * @param {*} data - array of object from "productCountryFeature" API
 * @returns - number - Maximum unique data from filtered array of object
 */
export const getMaxWeightFullcustoms  = (data) => {

const filteredMaximumWeightPerParcelWithFullCustoms = data
.filter(
  (ele) =>
    ele.addressType === CONSTANTS.MAX_WEIGHT_FULL_CUSTOMS.ADDRESS_TYPE &&
    ele.productCode === CONSTANTS.MAX_WEIGHT_FULL_CUSTOMS.PRO_CODE_1 &&
      ele.countryCode === CONSTANTS.MAX_WEIGHT_FULL_CUSTOMS.COUNTRY_CODE_GB,
)
.map((x) => x.maximumWeightPerParcelWithFullCustoms);

  const maximumWeightPerParcelWithFullCustoms = [...new Set(filteredMaximumWeightPerParcelWithFullCustoms)][0];
  return maximumWeightPerParcelWithFullCustoms;
};

/**
 * Method to get commodity (unit quantity*unit weight) total when shipment movement type for defaults
 * @param {*} values - object
 * @returns number
 */
export const getCommodityTotalWeightDefaults = (values) => {
  let commodityTotalWeight = 0;
  values?.clearanceItemData?.forEach((commodity) => {
    commodityTotalWeight += commodity.quantity * commodity.unitWeight;
  });
  const totalWeight = Number(parseFloat(commodityTotalWeight).toFixed(2));
  return totalWeight;
}

/**
 * Method to call the API with endpoint "/referencedata/products" 
 * when Parcel Handover Method is "Drop off at Service Point"
 * 
 * @param {*} destinationCountry - Country code
 * @returns - object
 */
export const getServicePointDropOffDetails = (destinationCountry) => {
  return axiosConfig
    .get(`${ServiceEndPoints.getMappedProducts}`)
    .then((response) => {
      response = response.data;

     // Filter out the product with productCode "204"
      const excludedCodes = [CONSTANTS.MISC_VALUES.PRODUCT_CODE_204, CONSTANTS.MISC_VALUES.PRODUCT_CODE_97];
      response = response.filter((x) => !excludedCodes.includes(x.productCode));
      
      if (destinationCountry.code === CONSTANTS.MISC_VALUES.GBR) {
        response = response.filter((x) => x.shipmentType === CONSTANTS.MISC_VALUES.SHIPMENT_TYPE_DOMESTIC);
      } else { 
        response = response.filter((x) => x.shipmentType === CONSTANTS.MISC_VALUES.SHIPMENT_TYPE_INTERNATIONAL);
      }

      // Maximum Service Point Collection Weight and Parcels
      let allServicePointMaxWeightList = response.map((x) => x.servicePointCollectionMaximumWeight);

      // Maximum Service Point Collection Weight and Parcels
      let allServicePointMinWeightList = response.map((x) => x.servicePointCollectionMinimumWeight);

      // Maximum Service Point Collection Per Parcels with full customs
      let allServicePointMaxWeightPerParcelsWithFullCustomsList = response.map(
        (x) => x.servicePointCollectionMaximumWeightPerParcelWithFullCustoms,
      );

      const servicePointCollection = {
        maxWeight: Math.max(...allServicePointMaxWeightList),
        minWeight: Math.max(...allServicePointMinWeightList),
        maxPerParcelsCustoms: Math.max(...allServicePointMaxWeightPerParcelsWithFullCustomsList),
      };

      return servicePointCollection;
    })
    .catch((err) => {
      console.log(err);
    });
};

/**
 * Method to get the customsDeclaration from products list for international
 *
 * @returns boolean
 */
export const getCustomDeclarationFromProducts = (allProducts = []) => {

   // Ensure allProducts is an array
  if (!Array.isArray(allProducts)) {
    throw new Error('Expected an array');
  }

  // Check if any product requires a customs declaration
  const showCustomDeclaration = allProducts.some(
    (product) =>
      product?.deliveryCapabilities?.customsDeclaration === CONSTANTS.CLERANCE_DECLARATION.CUSTOM_DECLARATION,
  );

  return showCustomDeclaration;
};

/**
 * Method to get the value of Maximum Weight Per Parcel With Full Customs
 * @returns - number
 */
  export const getMaxWeightPerParcel = (destinationCountry, dimsValidation, formikValues, servicePointCollectionData) => {
    if (destinationCountry.code === CONSTANTS.MISC_VALUES.GBR) {
      // For Domestic destinations
      if (formikValues.handOverMethod === CONSTANTS.MISC_VALUES.DRIVER_COLLECTION_HANDOVER_METHOD) {
        return dimsValidation?.maximumWeightPerParcelWithFullCustoms;
      } else if (formikValues.handOverMethod === CONSTANTS.MISC_VALUES.SERVICE_POINT_HANDOVER_METHOD) {
        return servicePointCollectionData?.maxPerParcelsCustoms;
      } else {
        return dimsValidation?.maximumWeightPerParcelWithFullCustoms;
      }
    } else {
      // For international destinations
      if (formikValues.handOverMethod === CONSTANTS.MISC_VALUES.SERVICE_POINT_HANDOVER_METHOD) {
        return servicePointCollectionData?.maxPerParcelsCustoms;
      }
    }
  };

  export const getMinTotalWeight = (formikValues, servicePointCollectionData, dimsValidation) => {
    let minWeight;

    if (formikValues.handOverMethod === CONSTANTS.MISC_VALUES.DRIVER_COLLECTION_HANDOVER_METHOD) {
      minWeight = dimsValidation.minWeight;
    } else if (formikValues.handOverMethod === CONSTANTS.MISC_VALUES.SERVICE_POINT_HANDOVER_METHOD) {
      minWeight = servicePointCollectionData?.minWeight;
    }
    return minWeight;
  };

  /**
   * Method to generate print label while creating the shipment
   */
  export const printLabelShipments = (shipment, index, lableName) => {
  const hasReturnShipment = !!shipment?.returnShipmentId;

  if (hasReturnShipment) {
    if (index === 0) {
      lableName = CONSTANTS.PICKLIST_LABELS.LABEL;
    } else if (index === 1) {
      lableName = CONSTANTS.PICKLIST_LABELS.RETURN_LABEL;
    } else if (index === 2) {
      lableName = CONSTANTS.PICKLIST_LABELS.RETURN_INSTRUCTIONS;
    } else if (index === 3) {
      lableName = CONSTANTS.PICKLIST_LABELS.PICKLIST;
    }
  } else {
    if (index === 0) {
      lableName = CONSTANTS.PICKLIST_LABELS.LABEL;
    } else if (index === 1) {
      lableName = CONSTANTS.PICKLIST_LABELS.PICKLIST;
    }
  }
  return lableName;
}

/**
 * Method to generate the label for Reprint
 */
export const generateLabelReprint = (lblResponse, labelResponse, index, lableName, values = {}) => {
  const labelsObject = Array.isArray(labelResponse)
    ? labelResponse[0]?.labels
    : labelResponse?.labels;

  const labelsArray = labelsObject && typeof labelsObject === 'object'
    ? Object.values(labelsObject)
    : [];

  values = values || {};

  if ((values.reprintLabel && (labelsArray.length === 1 || labelsArray.length === 3)) 
    || (values.reprintLabel && values.reprintPickList && labelsArray.length === 4)) {
    if (index === 0) {
      lableName = CONSTANTS.PICKLIST_LABELS.LABEL;
    } else if (index === 1) {
      lableName = CONSTANTS.PICKLIST_LABELS.RETURN_LABEL;
    } else if (index === 2) {
      lableName = CONSTANTS.PICKLIST_LABELS.RETURN_INSTRUCTIONS;
    } else if (index === 3) {
      lableName = CONSTANTS.PICKLIST_LABELS.PICKLIST;
    }
  } else if (labelResponse && labelsArray.length === 2 && values.reprintLabel && values.reprintPickList) {
    if (index === 0) {
      lableName = CONSTANTS.PICKLIST_LABELS.LABEL;
    } else if (index === 1) {
      lableName = CONSTANTS.PICKLIST_LABELS.PICKLIST;
    }
   } else if(values.reprintPickList && labelsArray.length === 1) {
    if (index === 0) {
      lableName = CONSTANTS.PICKLIST_LABELS.PICKLIST;
    }
  } else if(lblResponse && typeof lblResponse === 'string') {
    lableName = CONSTANTS.PICKLIST_LABELS.LABEL;
  }
  return lableName;
}

 /**
 * Method to get polling app Details for user guide links
 */
export const getDownloadUrlByType = (
  type,
  dispatch,
  onSuccess
) => {
  return () => {
    axiosConfig
        .get(`${ServiceEndPoints.pollingApp}?type=${type}`)
      .then((res) => {
        if (res.data?.downloadurl) {
          onSuccess(res.data.downloadurl);
        } else {
          dispatch(
            actions.setBottomAlert({
              msgs: [
                {
                  type: 'error',
                  msg: 'Download URL not found.',
                },
              ],
            })
          );
        }
      })
      .catch((err) => {
        dispatch(
          actions.setBottomAlert({
            msgs: [
              {
                type: 'error',
                msg: 'Failed to fetch download URL.',
              },
            ],
          })
        );
      });
  };
};

/**
 * Method to validate if commodity details have missing product identifiers
 * @param {*} commodityDetails 
 * @returns 
 */
export const hasMissingCommodityProductIdentifiers = (commodityDetails = []) =>
  Array.isArray(commodityDetails) && commodityDetails.length > 0 && commodityDetails.some(
    (commodity) =>
      !String(commodity?.merchant ?? '').trim() || !String(commodity?.nonStandardised ?? '').trim(),
  );
